import styled from 'styled-components';

export const SearchViewWrapper = styled.div`
    padding: 24px;
    .no-result {
        padding: 16px 0;
        width: 320px;
        line-height: 24px;
        color: #40596f;
        h3 {
            font-size: 16px;
        }
    }
    .link {
        color: rgba(0, 0, 0, 0.87);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover {
            opacity: 0.7;
        }
    }
`;

export const SearchViewHeader = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    padding: 25px;
    gap: 24px;
    background: #fff;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
    .header-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .header-info {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            font-size: 22px;
            .header-info-name {
                display: flex;
                flex-flow: column;
                justify-content: space-evenly;
                padding-bottom: 4px;
            }
            .results-number {
                display: inline-block;
                .text {
                    color: #00a5ac;
                    font-size: 16px;
                    font-weight: bold;
                    line-height: 1.75;
                }

                .icon {
                    color: #00a5ac;
                    display: inline-block;
                    padding-right: 5px;
                }
            }
        }
    }
`;

export const SearchHeaderInfo = styled.div``;
